import * as React from 'react'
import { render } from 'react-dom'
import NotFound from './components/NotFound'
import Accueil from './pages/Accueil/Accueil'
import Service from './pages/Service/Service'
import SuppData from './pages/SuppressionDonnees/SuppData'
import SearchCgu from './components/Search/SearchCgu'
import Resume from './pages/Resume/Resume'
import Clauses from './pages/Resume/Clauses'
import SelectionSite1 from './pages/SuppressionDonnees/SelectionSite/SelectionSite1'
import SelectionSite2 from './pages/SuppressionDonnees/SelectionSite/SelectionSite2'
import SelectionSite3 from './pages/SuppressionDonnees/SelectionSite/SelectionSite3'
import VerifAccount from './utils/Account/VerifAccount'
import SettingsLogged from './pages/UserProfil/Settings/Settings'
import SettingsLoggedPassword from './pages/UserProfil/SettingsPassword/SettingsPassword'
import Contact from './pages/Contact/Contact'
import CGU from './pages/Cgu/Cgu'
import Historique from './pages/Historiques/Historique'
import Aide from './pages/aide/label'

import { BrowserRouter, Switch, Route } from 'react-router-dom';

const Root = () => (
    <BrowserRouter>
        <Switch>
		<Route exact path='/' component={Accueil} />
		<Route exact path='/accueil' component={Accueil} />
        <Route exact path='/service' component={Service} />
		<Route exact path='/verif/:id' component={VerifAccount} />
        <Route exact path='/suppressiondonnees' component={SuppData} />
        <Route exact path='/searchcgu' component={SearchCgu} />
        <Route exact path='/resume' component={Resume} />
        <Route exact path='/clauses' component={Clauses}/>
        <Route exact path='/contact' component={Contact}/>
        <Route exact path='/selectionsite1' component={SelectionSite1} />
        <Route exact path='/selectionsite2' component={SelectionSite2} />
        <Route exact path='/selectionsite3' component={SelectionSite3} />
        <Route exact path='/settings' component={SettingsLogged} />
        <Route exact path='/settingspassword' component={SettingsLoggedPassword} />
        <Route exact path='/cgu' component={CGU} />
        <Route exact path='/historique' component={Historique} />
        <Route exact path='/aide' component={Aide} />
		<Route component={NotFound} />
        </Switch>
    </BrowserRouter>
)


render(
    <Root/>,
    document.getElementById('app')
)